(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discount-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('amalie-discount-bar')) {
    customElements.define('amalie-discount-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.messages = Array.from(this.querySelectorAll('[data-promotion]'));
        if (this.messages.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.current = 0;
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.messages.indexOf(event.target.closest('[data-promotion]'));
          if (index < 0) return;
          this.stop();
          this.show(index);
        }, options);
        this.start();
      }
      show(index) {
        this.current = index;
        this.messages.forEach((message, i) => { message.hidden = i !== index; });
      }
      start() {
        this.stop();
        if (document.hidden) return;
        this.timer = setInterval(() => this.show((this.current + 1) % this.messages.length), Number(this.dataset.interval) || 4000);
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() {
        this.stop();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-sloupce"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('paticka-sloupce')) {
    customElements.define('paticka-sloupce', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.update = () => this.querySelectorAll('details').forEach(detail => { detail.open = !this.media.matches; });
        this.preventDesktopToggle = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.media.addEventListener('change', this.update);
        this.addEventListener('click', this.preventDesktopToggle);
        this.update();
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.update);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
